module.exports = __webpack_public_path__ + "static/media/img_message_bar_android.3cb08aba.png";